import * as React from 'react';
import { cloneDeep } from 'lodash';
import '../index.css';
import VoteArea from '../../ContentItems/VoteArea';

export default class VoteSpecialWrapper extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const { dataList } = props;
    const voteAreaData = dataList.find((item) => item.type === 'voteArea');
    this.state = {
      leftAreaWidth: this.calcLeftAreaWidth(voteAreaData.data)
    };
  }
  componentWillReceiveProps(nextProps: Readonly<any>): void {
    const nextVoteData = nextProps?.dataList.find((item) => item.type === 'voteArea');
    const voteData = this.props?.dataList.find((item) => item.type === 'voteArea');
    if (voteData.data?.inputParam?.shopId !== nextVoteData.data?.inputParam?.shopId) {
      this.state = {
        leftAreaWidth: this.calcLeftAreaWidth(nextVoteData.data)
      };
    }
  }

  handleOnVote(updateParams) {
    const { puzzleContainerRef, indexPath } = this.props;
    // 投票成功后同步更新 puzzle 数据
    if (puzzleContainerRef) {
      const curData = cloneDeep(puzzleContainerRef?.getItem(indexPath));
      curData.json_data.content[2][3].data.voteStatus = updateParams.voteStatus;
      puzzleContainerRef?.setItem(indexPath, curData);
    }
    const leftAreaWidth = this.calcLeftAreaWidth(updateParams);
    this.setState({
      leftAreaWidth
    });
  }

  calcLeftAreaWidth(input) {
    const { heatLevel, voteStatus } = input || {};
    const {
      marginStyle
    } = this.props;
    // 投票控件最大宽度，默认按有一个火苗计算
    let voteAreaMaxWidth = voteStatus === 0 && heatLevel === 0 ? 82 : 108;
    // 如果投票状态是 0 且热度大于 0，补充最大宽度
    if (voteStatus === 0 && heatLevel > 0) {
      voteAreaMaxWidth += 16;
    }
    // 如果热度大于 1 的话，补充最大宽度
    if (heatLevel > 1) {
      voteAreaMaxWidth += 18 * (heatLevel - 1);
    }

    /**
     * 计算左区域宽度
     * 屏幕宽 - 投票区域最大宽度 - 左右间距 - 左右内边距 - 外边距
     */
    const leftAreaWidth = Mach.env.screenWidth - voteAreaMaxWidth - marginStyle.marginLeft - marginStyle.marginRight - 12 * 2;
    return leftAreaWidth;
  }

  render() {
    const {
      dataList, line, attachmentRender, parentLogData
    } = this.props;
    const leftAreaWidget = dataList.slice(0, -1);
    const voteData = dataList.find((item) => item.type === 'voteArea');
    return dataList?.length > 0 ? (
      /**
       * 安卓单端哪怕 procuct-content-item-container 给了 overflow: visible 也会截断，
       * 如果非要用 overflow 来实现的话，得把 procuct-content-container 的 overflow 也改掉
       * 风险太高，从行高下手把
       */
      <view
        key={line}
        className="procuct-content-item-container"
        style={{ marginTop: line === 0 ? 0 : 8, height: 24 }}
      >
        <view style={{ width: this.state.leftAreaWidth, overflow: 'hidden' }}>
          {attachmentRender(leftAreaWidget)}
        </view>
        <VoteArea data={voteData.data} parentLogData={parentLogData} customHandleVoteSuccess={this.handleOnVote.bind(this)} />
      </view>
    ) : null;
  }
}
